import {lazy, filter} from './lang.js';

export const print = (...str) => {
    return (...args) => {
        let effect = args[3];
        let cat = "";
        for (let s of str) {
            let _s  = lazy(s, ...args);
            if (!_s) {
                continue;
            }
            try {
                if (typeof s === "string") {
                    cat += s + " ";
                } else {
                    cat += JSON.stringify(_s) + " ";
                }
            } catch (e) {}
        }
        if (cat !== "") {
            effect.logs.push(cat);
        }
        return filter(true);
    };
};
